import { saveMemberData, saveTeamData } from '../utils/idb-utils';
// save team, member and team data to indexedDb
export function processMembersData(documents, callback) {
    Promise.all([
        saveMemberData(documents.users),
        saveTeamData(documents.teams)
    ]).catch((err)=>{
        // eslint-disable-next-line no-console
        console.error('error while saving members and teams', err);
    }).finally(()=>{
        callback({
            teams: documents.teams,
            users: documents.users
        });
    });
}
